
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/prijava",
      function () {
        return require("private-next-pages/prijava.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/prijava"])
      });
    }
  